var map = {
	"./1.svg": "27b0",
	"./2.svg": "0e4a",
	"./3.svg": "e4449",
	"./VIN精准评估.svg": "2ad9",
	"./保值率查询.svg": "7d2e",
	"./快速评估.svg": "7d8c",
	"./车型库查询.svg": "ffaa",
	"./迁入标准查询.svg": "ee3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d8a6";